import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, CommonModule, CommonModule, FormsModule, MatNativeDateModule, MatSelectModule, MatStepperModule, MatCheckboxModule,AuthLayoutComponent],
  selector: 'app-bienvenida',
  templateUrl: 'bienvenida.component.html',
  styleUrl: './bienvenida.component.css'
})
export class BienvenidaComponent {

  isLoading: boolean = false;
  formBuilder: FormBuilder = new FormBuilder;
  primerFormGroup: FormGroup;
  segundoFormGroup: FormGroup;
  user!: UsuarioDto;
  nombreDisabled: boolean = true
  get f() { return this.primerFormGroup.controls; }
  get l() { return this.segundoFormGroup.controls; }
  constructor(
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
  ) {

    const phoneRegex = /^\+?\d{1,4}?[ -.]?\(?\d{1,4}\)?[ -.]?\d{1,9}([ -.]?\d{1,9})?$/;

    this.user = this.loginService.getCurrentUser()

    const nombre = this.user?.nombre || '';
    const apellido = this.user?.apellido || '';
    const telefono = this.user?.telefono || '';

    this.primerFormGroup = this.formBuilder.group({
      Nombre: this.formBuilder.control(
        { value: `${nombre} ${apellido}`.trim(), disabled: true },
        Validators.compose([Validators.required, Validators.maxLength(50)])
      ),
      Telefono: [`${telefono}`.trim(), Validators.compose([Validators.required, Validators.pattern(phoneRegex)],)],
      TerminosCondiciones: [false, Validators.compose([Validators.requiredTrue])]
    });
    this.segundoFormGroup = this.formBuilder.group({
      NombreEmpresa: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      TelefonoEmpresa: ['', Validators.compose([Validators.required, Validators.pattern(phoneRegex)],)],
    });

  }

  habilitarNombre(): void {
    this.nombreDisabled = false;
    this.primerFormGroup.get('Nombre')?.enable();
  }

  ngOnInit(): void {

  }
}
